import { useFormik } from 'formik';
import React from 'react';
import { useState } from 'react';
import { BookButton, BookModal, BookTexField } from '../../components';
import { ChapterValidation } from '../BookChapters/validation';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CreateBookChapter, UpdateBookChapter } from "../../DAL/BooksChapters/bookChapters";
import { enqueueSnackbar } from "notistack";

const BookChapterModal = ({
  open,
  setOpen,
  action,
  singleBookChapter,
  tableCells,
  handleGetBookChapterData,
  languageData,
  bookData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.up('sm'));

  // Debug logs
  console.log("Modal props:", { action, singleBookChapter, open });

  const handleAddBookChapter = async(values) => { 
    setIsLoading(true);
    const data = {
        bookId: values?.bookId,
        chapterName: values?.chapterName,
        chapterNo: values?.chapterNo,
        url: values?.url || null
      };
    const response = await CreateBookChapter(data);
    if (response.statusCode == 200) {
      setIsLoading(false);
      enqueueSnackbar("Chapter added successfully", { variant: "success" });
      handleGetBookChapterData()
      setOpen(false);
      formik.handleReset();
    } else {
      setIsLoading(false);
      if (typeof response.message == "string") {
        enqueueSnackbar(response.message, { variant: "error" });
      } else {
        enqueueSnackbar("Invalid credentials", { variant: "error" });
      }
    }
  };

  const handleUpdateBookChapterChapter = async(values) => {
    setIsLoading(true);
    
    console.log("Update values:", values);
    console.log("Chapter ID:", values?.id);

    const data = {
      bookId: values?.bookId,
      chapterName: values?.chapterName,
      chapterNo: values?.chapterNo,
      url: values?.url || null
    };
    
    console.log("Update data:", data);
    const response = await UpdateBookChapter(values?.id, data);
    console.log("Update response:", response);
    if (response?.statusCode == 200) {
      setIsLoading(false);
      enqueueSnackbar("Chapter updated successfully", { variant: "success" });
      handleGetBookChapterData()
      setOpen(false);
      if (action === 'add') {
        formik.handleReset();
      }
    } else {
      setIsLoading(false);
      if (typeof response.message == "string") {
        enqueueSnackbar(response.message, { variant: "error" });
      } else {
        enqueueSnackbar("Invalid credentials", { variant: "error" });
      }
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id:
        action !== 'add' && singleBookChapter && singleBookChapter.id
          ? singleBookChapter.id
          : '',
        bookId:
        action !== 'add' && singleBookChapter && singleBookChapter.bookId
          ? singleBookChapter.bookId
          : '',
        chapterName:
        action !== 'add' && singleBookChapter && singleBookChapter.chapterName
          ? singleBookChapter.chapterName
          : '',
      chapterNo:
        action !== 'add' && singleBookChapter && singleBookChapter.chapterNo
          ? singleBookChapter.chapterNo
          : '',
      url:
        action !== 'add' && singleBookChapter && singleBookChapter.url
          ? singleBookChapter.url || ''
          : '',
    },
    validationSchema: ChapterValidation,
    onSubmit: values => {   
      console.log("Formik onSubmit called:", { action, values });
      setIsLoading(true);
      if (action === 'add') {
        console.log("Calling handleAddBookChapter");
        handleAddBookChapter(values);
      } else {
        console.log("Calling handleUpdateBookChapterChapter");
        handleUpdateBookChapterChapter(values);
      }
    },
  });

  const handleButtonClick = () => {
    console.log("Direct button click handler");
    console.log("Action:", action);
    console.log("Formik values:", formik.values);
    console.log("Formik errors:", formik.errors);
    console.log("Formik touched:", formik.touched);
    
    // Call formik submit
    formik.handleSubmit();
  };

  return (
    <BookModal
      open={open}
      formik={formik}
      setOpen={setOpen}
      title='Chapter'
      subtitle={`${action === 'add' ? 'Add' : 'Edit'} Chapter`}
    >
      {tableCells &&
        tableCells.map(
          t =>
            t.id !== 'actions' &&
            (t.id === 'bookId' ? (
              <BookTexField
                formik={formik}
                name={t.id}
                label={t.title}
                placeholder={`Enter ${t.title}`}
                key={t.id + 'cell'}
                select={true}
                selectOptions={bookData}
              />
            ) : (
              <BookTexField
                formik={formik}
                name={t.id}
                label={t.title}
                placeholder={`Enter ${t.title}`}
                key={t.id + 'cell'}
              />
            ))
        )}
      <BookButton
        onSubmit={handleButtonClick}
        title={`${action === 'add' ? 'Add' : 'Update'}`}
        type='primary'
        variant='contained'
        isLoading={isLoading}
        sx={{
          top: '0.625rem',
          marginBottom: '0.625rem'
        }}
      />
    </BookModal>
  );
};

export default BookChapterModal;

  